function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 5.25H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75zm-3-2.5H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18 7H6c-2.2 0-4 1.8-4 4v7c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4v-7c0-2.2-1.8-4-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.37 9.89c-.3-.24-.85-.47-1.73-.24l-2.73.75c-.85.22-1.4.94-1.4 1.83v3.5c-.2-.06-.4-.1-.62-.1a2.121 2.121 0 000 4.24c1.17 0 2.12-.95 2.12-2.12v-3.34l3.52-.96v1.37c-.2-.06-.4-.1-.62-.1a2.121 2.121 0 000 4.24c1.15 0 2.09-.92 2.11-2.07 0-.02.01-.03.01-.05v-5.35c0-.9-.36-1.37-.66-1.6zm-6.48 8.47c-.34 0-.62-.28-.62-.62a.621.621 0 011.24-.01c0 .35-.28.63-.62.63zm5.02-.91c-.34 0-.62-.28-.62-.62 0-.34.28-.62.62-.62.34 0 .62.28.62.62 0 .34-.28.62-.62.62z"
})));